function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.684 8.333h1.983A1.667 1.667 0 0 1 18.333 10v6.667a1.667 1.667 0 0 1-1.666 1.666H7.083c-1 0-1.916-.6-2.283-1.491l-2.917-5.834-.025-.05A2.5 2.5 0 0 1 4.167 7.5h4.166V3.333c0-.916.75-1.666 1.667-1.666h1.35l3.334 6.666zm-1.35 1.034l-3.017-6.034H10v5.834H4.167a.833.833 0 0 0-.775 1.133l2.916 5.85a.833.833 0 0 0 .775.517h6.25v-7.3zM15 10v6.667h1.667V10H15z" fill="currentColor" /></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/thumbs-up.icon.svg